import React from "react";

import { MaterialIcon } from "@pearsontechnology/aero-components";

import { intl } from "containers/LanguageProvider/IntlGlobalProvider";

import messages from "../messages";
import { Title, Wrapper, EtextHelpLink } from "./styles";

function EtextHelpView() {
  return (
    <Wrapper>
      <Title>{intl.formatMessage(messages.eTextHelpTitle)}</Title>
      <EtextHelpLink
        href="https://workspace-bronte.pearson.com/courseware/3f6e89f0-7379-11ee-ae66-771a7ee2d91c"
        target="_blank"
      >
        <MaterialIcon id="open_in_new"></MaterialIcon>
        {intl.formatMessage(messages.eTextHelpLink)}
      </EtextHelpLink>
    </Wrapper>
  );
}

export default EtextHelpView;
